import {
  mapPermissionDtoToModel,
  PermissionDto,
  PermissionId,
  PermissionModel,
} from 'api/dto/Permission.dto';
import { PermissionFlagModel } from 'api/dto/PermissionFlag.dto';

export type PermissionGroupDto = {
  id: string;
  name: string;
  objectIdentifier: string;
  flags: PermissionFlagModel[];
  permissions: PermissionDto[];
};

export type PermissionGroupModel = {
  id?: string;
  name: string;
  objectIdentifier?: string;
  flags?: PermissionFlagModel[];
  permissions?: PermissionModel[];
};

export function mapPermissionGroupDtoToModel(dto: PermissionGroupDto): PermissionGroupModel {
  return {
    id: dto.id,
    name: dto.name,
    objectIdentifier: dto.objectIdentifier,
    flags: dto.flags,
    permissions: dto.permissions ? dto.permissions.map(mapPermissionDtoToModel) : [],
  };
}

export namespace PermissionGroupModel {
  export function isClientAdmin(roleName: string) {
    return roleName === 'Client Admin';
  }

  export function hasPermissionByIdMatrixAccessFeature(
    permissionGroups: PermissionGroupModel[],
    id: string,
  ) {
    const permissionGroup =
      permissionGroups && permissionGroups.find((permissionGroup) => permissionGroup.id === id);

    return (
      permissionGroup &&
      permissionGroup.permissions.some(
        (permission) => permission.id === PermissionId.FEATURE_MATRIX_ACCESS,
      )
    );
  }
}
